import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, IconButton } from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { useSelector } from "react-redux";
import { getUserInfoFromToken } from "../utils/authUtils";
import usePermission from "../utils/usePermission";
import NotificationDropdown from "./NotificationDropdown";

export default function HeaderNotifications() {
  const { announcement, isLoding } = useSelector((state) => state.company);
  const { hasPermission } = usePermission();
  const [open, setOpen] = useState(false);
  const [userType, setUserType] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const { userType: type } = getUserInfoFromToken();
    setUserType(type);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const activeCount = useMemo(
    () => (announcement || []).filter((item) => item.active !== false).length,
    [announcement]
  );

  const canManage =
    userType === "Admin" ||
    hasPermission("notifications", "create") ||
    hasPermission("notifications", "edit");

  const toggleDropdown = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box ref={dropdownRef} className="app-header-notifications-wrap">
      <IconButton
        onClick={toggleDropdown}
        aria-label="Notifications"
        title="Notifications"
        className={`app-header-notifications${open ? " active" : ""}`}
        sx={{
          width: 40,
          height: 40,
          color: "var(--brand-navy)",
          "&:hover": {
            color: "var(--brand-orange)",
            bgcolor: "var(--brand-orange-light)",
          },
        }}
      >
        <NotificationsOutlinedIcon fontSize="small" />
        {activeCount > 0 && (
          <span className="app-header-notifications-badge">
            {activeCount > 9 ? "9+" : activeCount}
          </span>
        )}
      </IconButton>

      {open && (
        <NotificationDropdown
          announcements={announcement}
          loading={isLoding}
          canManage={canManage}
          onClose={() => setOpen(false)}
        />
      )}
    </Box>
  );
}
